
import { Component, Vue } from "vue-property-decorator";
import MissionOrdersTable from "@/components/mission-orders/table.vue";
import { Getter } from "vuex-class";

@Component({
  components: { MissionOrdersTable },
})
export default class MissionOrders extends Vue {
  @Getter private envCompanyId: number | null;
}
